// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyD3sHjinpDeRgBZlq4CiiVRjvHBKjMcVYY",
  authDomain: "testpushnotification-6e846.firebaseapp.com",
  projectId: "testpushnotification-6e846",
  storageBucket: "testpushnotification-6e846.appspot.com",
  messagingSenderId: "529903860138",
  appId: "1:529903860138:web:8643f91333aabb0a9853d3",
  measurementId: "G-308B2S4D98",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
